// src/components/CommentForm.js
import React, { useState } from 'react';
import { addComment } from '../firebase/comments';

const CommentForm = ({ user, userData, onError }) => {
  const [text, setText] = useState('');
  const [isCitation, setIsCitation] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    
    setIsSubmitting(true);
    setSuccessMessage('');
    
    try {
      const newComment = {
        author: user.displayName || user.email,
        authorId: user.uid,
        authorPhoto: user.photoURL,
        authorTitle: user.title || '', // Include author title from userData
        text,
        isCitation: isCitation,
        type: 'comment',
        course: 'exam-content',
        platform: 'cosknow',
        createdAt: new Date()
      };
      
      await addComment(newComment);
      
      // Reset form
      setText('');
      setIsCitation(false);
      
      // Show success message
      setSuccessMessage(isCitation ? 'Citation posted successfully!' : 'Comment posted successfully!');
      
      // Clear success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
      
    } catch (err) {
      onError('Failed to submit. Please try again.');
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className="form-container">
      <h3>Add a Comment</h3>
      
      {successMessage && (
        <div className="success-message">{successMessage}</div>
      )}
      
      <div className="form-group">
        <label htmlFor="comment-text">{isCitation ? 'Citation Text:' : 'Comment:'}</label>
        <textarea
          id="comment-text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={isCitation ? 
            "Enter the text you are citing that relates to the exam content..." : 
            "Share your thoughts about the exam content..."}
          rows="4"
          required
          disabled={isSubmitting}
        />
      </div>
      
      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={isCitation}
            onChange={(e) => setIsCitation(e.target.checked)}
            disabled={isSubmitting}
          />
          <span>Mark as Citation</span>
        </label>
      </div>
      
      <button 
        type="submit" 
        className="submit-button"
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Posting...' : (isCitation ? 'Post Citation' : 'Post Comment')}
      </button>
    </form>
  );
};

export default CommentForm;